/**
 * Build-time feature flags.
 *
 * CRA inlines `process.env.REACT_APP_*` at build time, so everything here is a
 * constant in the bundle rather than a runtime lookup. Flipping one of these
 * means a rebuild, which is the point: they are release switches, not settings.
 */

const isOn = (value?: string): boolean => {
    const normalised = String(value ?? '')
        .trim()
        .toLowerCase();
    return normalised === 'true' || normalised === '1' || normalised === 'yes';
};

/**
 * Mirrors the backend's PASSWORD_LOGIN_ENABLED, which now also defaults to
 * **false**: sign-in is a one-time code or Google, and nothing else. While this
 * is off the password forms, the "Forgot password?" link and the reset pages are
 * absent from the UI, and the API answers 403 `{ passwordLoginDisabled: true }`
 * to anyone who calls the endpoint anyway.
 *
 * The components behind it (PasswordLoginForm, PasswordSignUpForm,
 * PageForgetpass, PageResetPassword) are deliberately kept in the tree: setting
 * REACT_APP_PASSWORD_LOGIN_ENABLED=true and rebuilding brings the whole path
 * back if email and Google both have a bad day.
 *
 * Keep the two in sync: this flag only hides the UI, the backend flag is what
 * actually refuses the request.
 */
export const PASSWORD_LOGIN_ENABLED = isOn(process.env.REACT_APP_PASSWORD_LOGIN_ENABLED);

/**
 * Google Identity Services client id. Empty until the Google Cloud project is
 * set up, and every consumer has to cope with that - see GoogleSignInButton.
 */
export const GOOGLE_CLIENT_ID = String(process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '').trim();

export const GOOGLE_SIGN_IN_ENABLED = GOOGLE_CLIENT_ID.length > 0;
